import { toastr } from "react-redux-toastr";
import { SHIPPING_ACTION_TYPES } from "./actionTypes";
import { shippingApi } from "./api";

export const shippingActions = {
    calculateRequest: () => ({
        type: SHIPPING_ACTION_TYPES.CALCULATE_REQUEST,
    }),
    calculateSuccess: (data) => ({
        type: SHIPPING_ACTION_TYPES.CALCULATE_SUCCESS,
        payload: data,
        meta: { timestamp: Date.now() },
    }),
    calculateFailure: (error) => ({
        type: SHIPPING_ACTION_TYPES.CALCULATE_FAILURE,
        payload: { error },
        error: true,
    }),

    setSelectedOption: (optionKey) => ({
        type: SHIPPING_ACTION_TYPES.SET_SELECTED_OPTION,
        payload: { optionKey },
    }),

    setAddress: (address) => ({
        type: SHIPPING_ACTION_TYPES.SET_ADDRESS,
        payload: { address },
    }),
    clearAddress: () => ({
        type: SHIPPING_ACTION_TYPES.CLEAR_ADDRESS,
    }),

    resetShipping: () => ({
        type: SHIPPING_ACTION_TYPES.RESET_SHIPPING,
    }),
};

export const fetchPickupPoints = (shippingMethod) => {
    return async (dispatch, getState) => {
        const state = getState();
        const shipping = state.shipping;

        if (shipping.pickupPointsLoading) return;

        const address = shipping.address;
        if (!address?.city) return;

        const cartItems = (state.cart?.items || []).map(item => ({
            productId: item.id,
            quantity: item.quantity || 1,
            variationId: item.virtual ? 0 : (item.variationId || 0),
            virtual: item.virtual || false,
        }));
        if (cartItems.length === 0) return;

        dispatch({ type: SHIPPING_ACTION_TYPES.FETCH_PICKPOINTS_REQUEST, meta: { shippingMethod } });

        try {
            const result = await shippingApi.fetchDeliveryPoints({
                shippingMethod,
                address,
                cartItems,
            });

            const currentOption = getState().shipping.selectedOption || '';
            const currentMethod = currentOption.split('::')[0];
            if (currentMethod !== shippingMethod) return;

            dispatch({
                type: SHIPPING_ACTION_TYPES.FETCH_PICKPOINTS_SUCCESS,
                payload: {
                    points: result.points,
                    options: result.options,
                },
            });
        } catch (error) {
            dispatch({
                type: SHIPPING_ACTION_TYPES.FETCH_PICKPOINTS_FAILURE,
                payload: { error: error.message },
            });
        }
    };
};

export const selectPickupPoint = (point) => ({
    type: SHIPPING_ACTION_TYPES.SELECT_PICKUP_POINT,
    payload: { point },
});

export const calculateShipping = (cartItems, addressFields) => {
    return async (dispatch, getState) => {
        const state = getState().shipping;

        if (!addressFields?.city) {
            toastr.warning('Внимание', 'Укажите адрес для расчёта доставки');
            return;
        }

        if (!cartItems || cartItems.length === 0) {
            toastr.warning('Внимание', 'Корзина пуста');
            return;
        }

        dispatch(shippingActions.calculateRequest());

        try {
            const result = await shippingApi.calculate(cartItems, addressFields);

            dispatch(shippingActions.calculateSuccess(result));

            if (result.minPickup) {
                const key = `${result.minPickup.shipping_method}::${result.minPickup.shipping_type}`;
                dispatch(shippingActions.setSelectedOption(key));
            } else if (result.minDelivery) {
                const key = `${result.minDelivery.shipping_method}::${result.minDelivery.shipping_type}`;
                dispatch(shippingActions.setSelectedOption(key));
            }

            return result;
        } catch (error) {
            console.error('Shipping calculate error:', error);
            dispatch(shippingActions.calculateFailure(error.message));
            toastr.error('Ошибка', `Не удалось рассчитать доставку: ${error.message}`);
            throw error;
        }
    };
};

export const setAddressAndCalculate = (address, cartItems) => {
    return async (dispatch) => {
        dispatch(shippingActions.setAddress(address));

        if (address?.city && cartItems?.length > 0) {
            await dispatch(calculateShipping(cartItems, {
                country: 'RU',
                fullAddress: address.fullAddress || '',
                city: address.city || '',
                stateCode: address.stateCode || '',
                geoLat: address.geoLat || '',
                geoLon: address.geoLon || '',
                postal_code: address.postalCode || '',
            }));
        }
    };
};